import { AuthProvider } from "@/contexts/auth-context";
import { LanguageProvider } from "@/contexts/language-context";
import { ToastProvider } from "@/contexts/toast-context";
import LoadingProvider from "@/providers/loading-provider";
import LocalizationProvider from "@/providers/localization-provider";
import StyleProviders from "@/providers/style-providers";
import AppRoutes from "@/router";

function App() {
  return (
    <StyleProviders>
      <LoadingProvider>
        <LanguageProvider>
          <LocalizationProvider>
            <ToastProvider>
              <AuthProvider>
                <AppRoutes />
              </AuthProvider>
            </ToastProvider>
          </LocalizationProvider>
        </LanguageProvider>
      </LoadingProvider>
    </StyleProviders>
  );
}

export default App;
